import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { date, money } from '../../lib/format';
import { useInvestorScope } from '../../store/selectors';
import { Card, SectionLabel, shortEntityName } from '../common';

export default function CompletedInvestments({
  entity,
  onOpenExit,
}: {
  entity: string;
  onOpenExit: (holderId: string, fundId: string) => void;
}) {
  const scope = useInvestorScope();
  const closed = scope.closedHoldings.filter(
    (item) => entity === 'ALL' || item.holderId === entity,
  );
  if (closed.length === 0) return null;
  return (
    <>
      <SectionLabel>Completed investments</SectionLabel>
      <Stack spacing={1.25}>
        {closed.map((item) => {
          const fund = scope.funds.find((candidate) => candidate.id === item.fundId);
          const holder = scope.holders.find((candidate) => candidate.id === item.holderId);
          const gain = item.returned + item.income - item.invested;
          return (
            <Card key={`${item.holderId}-${item.classId}`}>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="space-between"
                spacing={1.5}
              >
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>
                    Repaid and closed {date(item.lastDate)}
                  </Typography>
                  <Typography sx={{ fontWeight: 700 }}>{fund?.name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {holder ? shortEntityName(holder) : ''} · held {date(item.firstDate)} to{' '}
                    {date(item.lastDate)}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: { sm: 'right' } }}>
                  <Typography sx={{ fontWeight: 800, color: 'success.main' }}>
                    +{money(gain)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {money(item.invested)} returned in full · {money(item.income)} income
                  </Typography>
                </Box>
              </Stack>
              <Button
                size="small"
                sx={{ mt: 1, ml: -1 }}
                onClick={() => onOpenExit(item.holderId, item.fundId)}
              >
                View exit statement
              </Button>
            </Card>
          );
        })}
      </Stack>
    </>
  );
}
